import React from "react";
import { RequestService } from "../../services/RequestService";
import { Upload, Icon, message, Modal } from "antd";
import { IMAGE_SERVER } from "../../../common/constants/systemUrls";

import "./uploadPhoto.css";

class PhotoUpload extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      image_url: null,
      previewVisible: false
    };
    this.handleLoading = this.handleLoading.bind(this);
  }

  componentDidMount() {
    const { image_url } = this.props;

    if (image_url !== null) {
      if (image_url instanceof File) {
        this.handleChangePhoto(image_url);
      } else {
        this.setState(() => ({
          image_url
        }));
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.image_url !== prevProps.image_url) {
      if (this.props.image_url instanceof File) {
        this.handleChangePhoto(this.props.image_url);
      } else {
        this.setState(() => ({
          image_url: this.props.image_url
        }));
      }
    }
  }

  get_Base64(img, callback) {
    try {
      const reader = new FileReader();
      reader.addEventListener("load", () => callback(reader.result));
      reader.readAsDataURL(img);
    } catch {
      callback(null);
    }
  }

  // Загрузка фотографии

  handleChangePhoto = file => {
    this.get_Base64(file, image_url =>
      this.setState(
        () => ({
          image_url: image_url,
          loading: false
        }),
        () => {
          this.props.update && this.props.update(file);
        }
      )
    );
  };

  // Обработка фотографии
  before_upload_photo = file => {
    let imgFormats = ["image/jpg", "image/jpeg", "image/png", "image/gif"];
    const isJPG = imgFormats.includes(file.type);
    const isLt1M = file.size / 10240 / 10240 < 1;
    if (!isJPG) {
      message.error("Изображение должно быть в формате jpg, jpeg, png, gif!");
    }
    if (!isLt1M) {
      message.error("Изображение должно быть меньше 10 МБ!");
    }
    return isJPG && isLt1M;
  };

  // Удаление фото
  remove_upload_photo = e => {
    e.stopPropagation();
    let obj = {};
    if (this.props.data && this.props.data.photo_number) {
      obj[`photo${this.props.data.photo_number}`] = null;
    } else {
      obj["photo"] = null;
      obj["picture"] = null;
    }
    if (this.props.deleteAction) {
      const { deleteAction } = this.props;
      console.log(this.props.data);
      RequestService.delete(deleteAction, {
        params: this.props.data
      })
        .then(() => {
          message.success("Фото успешно удалено!");
        })
        .catch(e => {
          console.error(e);
          message.error("Не удалось удалить фото!");
        });
    }

    this.setState(
      () => ({
        image_url: null
      }),
      () => {
        if (this.props.form) {
          this.props.form.setFieldsValue({ ...obj });
        }
      }
    );
  };

  show_preview_image = () => {
    this.setState({
      previewVisible: true
    });
  };

  hide_preview_image = () => {
    this.setState({
      previewVisible: false
    });
  };

  handleLoading() {
    this.setState(state => ({
      loading: !state.loading
    }));
  }

  render() {
    const { image_url, previewVisible } = this.state;
    const { action } = this.props;
    return (
      <div className="upload-wrap">
        <Upload
          {...this.props}
          onStart={file => {
            this.handleLoading();
          }}
          onSuccess={url => {
            this.props.update && this.props.update(url);
            message.success("Фото успешно добавлено/обновлено!");
            this.setState((state, props) => ({
              loading: false,
              image_url: url
            }));
          }}
          onError={err => {
            console.error(err)
            message.error("Не удалось добавить/обновить фото!");
            this.setState((state, props) => ({
              loading: false
            }));
          }}
          customRequest={({ action, data, file, onError, onSuccess }) => {
            if (action) {
              const formData = new FormData();
              if (data) {
                Object.keys(data).forEach(key => {
                  formData.append(key, data[key]);
                });
              }
              formData.append("image_file", file);
              RequestService.post(action, formData)
                .then(response => onSuccess(response.data.url))
                .catch(onError);
            } else {
              this.handleChangePhoto(file);
            }
          }}
          className="upload upload_photo"
          listType="picture-card"
          showUploadList={false}
          beforeUpload={this.before_upload_photo}
        >
          {image_url ? (
            <div>
              <img
                className="upload__img"
                src={action ? `${IMAGE_SERVER}${image_url}` : image_url}
                alt={this.props.name}
              />
              {!this.props.disabled && (
                <div
                  className="upload__delete"
                  onClick={this.remove_upload_photo}
                  disabled={this.props.disabled}
                >
                  <Icon
                    component={() => (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2.93424 2.93424C3.14781 2.72067 3.49407 2.72067 3.70764 2.93424L8 7.2266L12.2924 2.93424C12.5059 2.72067 12.8522 2.72067 13.0658 2.93424C13.2793 3.14781 13.2793 3.49407 13.0658 3.70764L8.77339 8L13.0658 12.2924C13.2793 12.5059 13.2793 12.8522 13.0658 13.0658C12.8522 13.2793 12.5059 13.2793 12.2924 13.0658L8 8.77339L3.70764 13.0658C3.49407 13.2793 3.14781 13.2793 2.93424 13.0658C2.72067 12.8522 2.72067 12.5059 2.93424 12.2924L7.2266 8L2.93424 3.70764C2.72067 3.49407 2.72067 3.14781 2.93424 2.93424Z"
                          fill="#323232"
                        />
                      </svg>
                    )}
                  />
                </div>
              )}
            </div>
          ) : (
            <div>
              <Icon
                className="upload__icon"
                type={this.state.loading ? "loading" : "picture"}
              />
              <div className="upload__title">
                {this.props.disabled ? "Нет фото" : "Загрузите фотографию"}
              </div>
            </div>
          )}
        </Upload>
        {image_url &&
          (!this.props.disabled ? null : (
            <div
              className="upload__show-preview"
              onClick={this.show_preview_image}
            />
          ))}
        <Modal
          className="upload__modal"
          visible={previewVisible}
          footer={null}
          onCancel={this.hide_preview_image}
        >
          <img
            style={{ width: "100%" }}
            src={action ? `${IMAGE_SERVER}${image_url}` : image_url}
            alt="img"
          />
        </Modal>
      </div>
    );
  }
}

export default PhotoUpload;
